export default function FileUpload({ handleFileSelected, key1, buttonText, handleClick }) {
    return (
        <div className="flex h-80 w-full flex-col items-center justify-center rounded-lg bg-white p-4">
            <label
                htmlFor={`dropzone-file-${key1}`}
                className="flex w-full flex-1 cursor-pointer flex-col items-center justify-center rounded-lg border border-dashed border-primary-200"
            >
                <svg
                    className="mb-3 h-8 w-8 text-primary-700"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                >
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                </svg>
                <p className="font-Mulish text-sm font-semibold text-secondary">Choose a photo</p>
                <p className="mt-1 font-Mulish text-xs text-graphite">PNG, JPG, or WEBP</p>
                <input
                    id={`dropzone-file-${key1}`}
                    type="file"
                    accept="image/png,image/jpeg,image/webp"
                    className="hidden"
                    onChange={handleFileSelected}
                />
            </label>

            <p className="my-3 font-Mulish text-sm text-graphite">or</p>

            <button
                type="button"
                className="w-full rounded-full border border-primary-200 bg-white px-4 py-2.5 font-Mulish text-sm text-primary-700 hover:bg-primary-50"
                onClick={handleClick}
            >
                {buttonText}
            </button>
        </div>
    );
}
